var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "boat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.051,
    height: 17.051,
    viewBox: "0 0 17.051 17.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_87479",
    "data-name": "Path 87479",
    d: "M9.019,13.022v-1H15.41L9.019,1.36V0H8.033V13.022H0l3.3,4.03H13.762l3.289-4.03Zm0,0",
    fill: "#63849c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87480",
    "data-name": "Path 87480",
    d: "M51.7,141.008l-5.482,7.326H51.7Zm0,0",
    transform: "translate(-44.68 -136.312)",
    fill: "#63849c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoat);
export default __webpack_public_path__ + "static/media/boat.26f00852ddccfbabb26b554bdbccb686.svg";
export { ForwardRef as ReactComponent };